module.exports = {"confirm":"Confirm where you live","hint":"Country where you currently live","other":"Other country","residence":"Choose country"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/residence.json
// module id = 666
// module chunks = 247 1433